import { IncidenciaUsuario } from "./incidenciaUsuario";

export class IncidenciaUsuarioCategoria {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly CategoriaPadreId: number | null,
    public MostrarEnDashBoard: boolean,
    public CodigoRequerido: boolean,
    public Activo: boolean,
    public readonly IncidenciaUsuarioCategoriaCustoms: IncidenciaUsuarioCategoriaCustom[]
  ) {}
}

export class SearchIncidenciaUsuarioCategoriaRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly VerSoloActivos: boolean | null,
    public readonly VerSoloPadres: boolean | null
  ) {}
}

export class SaveIncidenciaUsuarioCategoriaDto {
  constructor(
    public Nombre: string | null,
    public Codigo: string | null,
    public CategoriaPadreId: number | null,
    public MostrarEnDashBoard: boolean | null,
    public CodigoRequerido: boolean | null,
    public Activo: boolean,
    public IncidenciaUsuarioCategoriaCustomDtos: IncidenciaUsuarioCategoriaCustomDto[]
  ) {}
}

export class IncidenciaUsuarioCategoriaDto {
  constructor(
    public Id: number,
    public Nombre: string | null,
    public Codigo: string | null,
    public CategoriaPadreId: number,
    public MostrarEnDashBoard: boolean,
    public CodigoRequerido: boolean,
    public Activo: boolean,
    public IncidenciaUsuarioCategoriaCustomDtos: IncidenciaUsuarioCategoriaCustomDto[]
  ) {}
}

export class SearchIncidenciaUsuarioCategoriaResponse {
  constructor(
    public readonly count: number,
    public readonly result: IncidenciaUsuarioCategoriaDto[]
  ) {}
}

export class IncidenciaUsuarioCategoriaCustom{
  constructor(
    public readonly Id: number,
    public readonly NombreCampo: string | null,
    public readonly TipoDato: string | null,
    public readonly IncidenciaUsuarioCategoriaId: number,
    public readonly Requerido: boolean,
    public Activo: boolean,
  ){}
}


export class IncidenciaUsuarioCategoriaCustomDto{
  constructor(
    public Id: number,
    public NombreCampo: string | null,
    public TipoDato: string | null,
    public IncidenciaUsuarioCategoriaId: number,
    public Requerido: boolean,
    public Activo: boolean,
  ){}
}

export class IncidenciaUsuarioCampoCustom{
  constructor(
    public readonly Id: number,
    public readonly Valor: string | null,
    public readonly IncidenciaUsuarioCategoriaCustomId: number,
    public readonly IncidenciaUsuarioCategoriaCustom: IncidenciaUsuarioCategoriaCustom,
    public readonly IncidenciaUsuarioId: number,
    public readonly IncidenciaUsuario: IncidenciaUsuario,
    public Activo: boolean,
  ){}
}

export class SaveIncidenciaUsuarioCampoCustom{
  constructor(
    public Id: number,
    public Valor: string | null,
    public IncidenciaUsuarioCategoriaCustomId: number,
    public IncidenciaUsuarioId: number,
    public Activo: boolean,
  ){}
}
